import React from 'react';
import PropTypes from 'prop-types';
import Usp from '../../ui_usp/component';
import SiteRatingText from '../../ui_site-rating-text/component';
import { getFeature } from '@utils';
import Text from '@text';
import { IS_B2B } from '@config';

import './styles.scss'

const Usps = ({ product }) => {
  const { isActive } = getFeature('reviewRating');
  const showReturnUsp = !product.isEbook && !IS_B2B;

  return (
    <div className='usps-pdp'>
      {showReturnUsp && (
        <Usp icon="check">
          <Text>pdp.usp.returns.regular</Text>
        </Usp>
      )}

      {!!product.storeDelivery && (
        <Usp icon="check"><Text>pdp.usp.storedelivery</Text></Usp>
      )}

      {isActive && (
        <Usp icon="check">
          <SiteRatingText textKey="pdp.usp.rating" />
        </Usp>
      )}
      <span title="Anchor used for microcopy (deprecated)" id="datatrics-0" />
      <span title="Datatrics anchor for USP's" id="datatrics-pdp-usps" />
    </div>
  );
};

Usps.propTypes = {
  store: PropTypes.object,
  product: PropTypes.object,
};

export default Usps;
